import { render, staticRenderFns } from "./AgendarPedidoPanel.vue?vue&type=template&id=4e4b5324&scoped=true&"
import script from "./AgendarPedidoPanel.vue?vue&type=script&lang=js&"
export * from "./AgendarPedidoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b5324",
  null
  
)

export default component.exports